import { Component, OnInit } from '@angular/core';
import { ScriptsModule } from '../../modules/scripts.module';
import { ContactService } from '../../services/general/contact.service';
import { ActivatedRoute, Router } from '@angular/router';

declare var jquery:any;
declare var $ :any;


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
  providers: [ContactService]
})
export class ContactComponent implements OnInit {


 public model; 
 public tituloContact;
 public mensajeContact;
 public rutaContact;
  
  constructor(public route: ActivatedRoute,private router: Router,private cs:ContactService) { }  

  ngOnInit() {
    let scripts = new ScriptsModule;
    scripts.loadScript('assets/js/scripts/contact.js');
    this.model={contacto:false};
  }

  onSubmit(){     
      
  $('#divCargador').show();
    this.cs.newContacto(JSON.stringify(this.model)).then(resc => {
           this.tituloContact="";
           this.mensajeContact="Pronto estaremos en contacto,Gracias por utilizar nuestros servicios !!";
           this.rutaContact="/home";
          $('#divCargador').hide();
          $('#modalNotif').modal('show');
        });
            
  }
  get currentContact() { return JSON.stringify(this.model); }
  
  }


// WEBPACK FOOTER //
// ./src/app/components/contact/contact.component.ts